module.exports = __webpack_public_path__ + "static/media/external.35ea51e2.svg";